import { UserWalletLedgersQuery } from "../../../../__generated__/graphql";
import {
  formatLedgerType,
  formatLedgerAmount,
  formatDate,
} from "../utils/wallet-utils";

type WalletLedgerItem = UserWalletLedgersQuery["userWalletLedgers"][number];

interface LedgerItemProps {
  ledger: WalletLedgerItem;
}

const LedgerItem: React.FC<LedgerItemProps> = ({ ledger }) => {
  const dateStr = formatDate(ledger.createdAt, "item");
  const typeStr = formatLedgerType(ledger.type);
  const amountStr = formatLedgerAmount(ledger.amount, ledger.direction);
  const balanceStr = ledger.balanceAfterAvailable
    ? `잔액 ${ledger.balanceAfterAvailable.toLocaleString()}원`
    : "";

  return (
    <div className="flex justify-between items-start py-3 px-4">
      {/* 왼쪽 정렬 */}
      <div className="flex-1 flex flex-col items-start">
        <div className="text-sm text-gray-500 mb-1">{dateStr}</div>
        <div className="font-bold text-base mb-1">{typeStr}</div>
        {ledger.memo && (
          <div className="text-sm text-gray-500 whitespace-pre-wrap break-words">
            {ledger.memo}
          </div>
        )}
      </div>

      {/* 오른쪽 정렬 */}
      <div className="flex flex-col items-end ml-4">
        <div
          className={`text-base font-semibold mb-1 ${
            ledger.direction === "IN" ? "text-blue-600" : "text-gray-900"
          }`}
        >
          {amountStr}
        </div>
        {balanceStr && (
          <div className="text-xs text-gray-500">{balanceStr}</div>
        )}
      </div>
    </div>
  );
};

export default LedgerItem;
